export class WatermarkingConfigurationInkModel {
    public id: number;
    public heartbeatMin: number;
    public technology: string;
  
    constructor() {
      this.id = 0;
      this.heartbeatMin = 0;
      this.technology = "";
    }
  }
  